import React from 'react';

import config from '../../../../config';
import t from '../../../../lib/I18n';

import Icon from '../../../general/Icon';
import ExternalLink from '../../../general/ExternalLink';
import FormattedHTMLMessage from '../../../general/FormattedHTMLMessage';
import BAlert, { bAlertType } from '../../../general/BAlert';

export default function KeyGoRegistrationWarning () {
    const keygoBrand = <FormattedHTMLMessage message='account.smartcard.text.keygo' />;
    return (
        <div className="padding-top padding-bottom">
            <div className="confirmation">
                <Icon icon="warning margin-bottom--sm otrl-xl text-center" />
                <p className="text-weight--normal alert-warning">{ t('account.smartcard.keygo.registrationWarning.title') }</p>
                <BAlert type={ bAlertType.WARNING } className="text-center">
                    <FormattedHTMLMessage message="account.smartcard.keygo.registrationWarning.alert"
                    keygobrand={ keygoBrand }
                    />
                </BAlert>
                <FormattedHTMLMessage
                    splitParagraphs
                    paragraphTagName="li"
                    tagName="ul"
                    className="list-styled text-left text-weight--normal margin-top--sm"
                    message="account.smartcard.keygo.registrationWarning.list"
                    keygobrand={ keygoBrand }
                    moreDetails={
                        <ExternalLink
                            href={ config.get('keyGoInformationUrl') }
                            message="global.here" />
                    } />
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/account/smartcard/keyGoRegistration/Warning.js